export default async function auth({ to, next, store }) {
    const isAuthenticated = store.getters['auth/isAuthenticated'] || store.getters.isAuthenticated;

    if (!isAuthenticated) {
        return next({
            name: 'Login',
            query: { redirect: to.fullPath } // Saves the target path for post-login redirect
        });
    }

    if (isAuthenticated && to.name === 'Login') {
        return next({ name: 'Home' });
    }

    return next();
}

// import store from '@/store';

// export default async function auth({ to, next }) {
//     let isAuthenticated = store.getters['auth/isAuthenticated'] || store.getters.isAuthenticated;
//     const token = localStorage.getItem('access_token');
//     const hasToken = Boolean(token && token !== 'null' && token !== 'undefined');
//
//     if (!isAuthenticated && hasToken) {
//         console.warn('user not authenticated and token not exist');
//         try {
//             await store.dispatch('fetchUser');
//             isAuthenticated = true;
//         } catch (error) {
//             // Token expired or invalid -> wipe local auth
//             store.commit('auth/CLEAR_AUTH');
//             localStorage.removeItem('access_token');
//             isAuthenticated = false;
//         }
//     }
//
//     if (!isAuthenticated) {
//         console.warn('user not authenticated or token exist');
//         if (to.name !== 'Login') {
//             return next({
//                 name: 'Login',
//                 query: { redirect: to.fullPath } // Retains target route for post-login redirect
//             });
//         }
//         return next();
//     }
//
//     // 3. Authenticated User Access Control
//     if (to.name === 'Login') {
//         console.warn('user authenticated login block');
//         return next({ name: 'Home' }); // Stops logged-in users from seeing login screen
//     }
//
//     return next();
// }

//
// export default function auth({ next, router }) {
//     // Check authentication status from store
//     const isAuthenticated = store.getters['auth/isAuthenticated'] || store.getters.isAuthenticated || false;
//     const token = localStorage.getItem('access_token');
//
//     // Check if token exists and is valid
//     const hasValidToken = token !== null && token !== undefined && token !== 'null' && token !== 'undefined';
//
//     // User is authenticated if store says so AND token exists
//     const isLoggedIn = isAuthenticated && hasValidToken;
//
//     // If not authenticated, redirect to login
//     if (!isLoggedIn) {
//         // Clear any stale auth data
//         store.commit('auth/CLEAR_AUTH');
//
//         // If not already on login page, redirect
//         if (router.currentRoute.name !== 'Login') {
//             return router.push({
//                 name: 'Login',
//                 query: { redirect: router.currentRoute.fullPath }
//             });
//         }
//         return next();
//     }
//
//     // If authenticated and trying to access login page, redirect to home
//     if (router.currentRoute.name === 'Login') {
//         return router.push({ name: 'Home' });
//     }
//
//     return next();
// }
